interface LogoControllerOptions {
	datauri: string;
	redirectUrl: string;
}
export class LogoController {
	private _logoDisplayed = false;
	private _datauri: string | undefined;
	private _redirectUrl = 'https://polygonjs.com';
	display(options: LogoControllerOptions) {
		this._logoDisplayed = true;
		this._datauri = options.datauri;
		this._redirectUrl = options.redirectUrl;
	}
	displayed() {
		return this._logoDisplayed;
	}
	datauri() {
		return this._datauri;
	}
	redirectUrl() {
		return this._redirectUrl;
	}
}
